export default __webpack_public_path__ + "static/media/4.69943f40.jpg";